export default __webpack_public_path__ + "static/media/pizza1.471b46d7.jpg";